var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-groups",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "category"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.113,0H3.9C1.342,0,0,1.342,0,3.885V6.1C0,8.645,1.342,9.987,3.885,9.987H6.1c2.543,0,3.885-1.342,3.885-3.885V3.885C10,1.342,8.657,0,6.113,0Z",
    transform: "translate(2.333 2.333)",
    fill: "#222227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M6.1,0H3.885C1.342,0,0,1.342,0,3.885V6.1C0,8.645,1.342,9.987,3.885,9.987H6.1c2.543,0,3.885-1.342,3.885-3.885V3.885C9.987,1.342,8.645,0,6.1,0Z",
    transform: "translate(15.68 2.333)",
    fill: "#222227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M6.1,0H3.885C1.342,0,0,1.342,0,3.885V6.1C0,8.645,1.342,9.987,3.885,9.987H6.1c2.543,0,3.885-1.342,3.885-3.885V3.885C9.987,1.342,8.645,0,6.1,0Z",
    transform: "translate(15.68 15.668)",
    fill: "#222227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M6.113,0H3.9C1.342,0,0,1.342,0,3.885V6.1C0,8.657,1.342,10,3.885,10H6.1c2.543,0,3.885-1.342,3.885-3.885V3.9C10,1.342,8.657,0,6.113,0Z",
    transform: "translate(2.333 15.668)",
    fill: "#222227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H28V28H0Z",
    transform: "translate(28 28) rotate(180)",
    fill: "none",
    opacity: 0
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGroup);
export default __webpack_public_path__ + "static/media/icon-group.61b9f5a505daa9e51e50cc4c67f4f0ec.svg";
export { ForwardRef as ReactComponent };